import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationGuard  {
  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.auth.isLoggedIn()) {
      this.router.navigate(['/login']);
      return false;
    }

    const requiredPermission = route.data['permission'];
    if (requiredPermission) {
      // Chave canônica achatada: "recurso:acao", só "recurso", ou multi-segmento
      // (ex.: "client:report:visualizar", cujo recurso é "client:report").
      // hasPermissionKey resolve contra os pares (recurso, acao) armazenados,
      // sem precisar adivinhar onde fica o split.
      if (!this.auth.hasPermissionKey(requiredPermission)) {
        const home = this.auth.getHomeRoute();
        if (home !== '/login') this.router.navigate([home]);
        else this.router.navigate(['/login']);
        return false;
      }
    }

    return true;
  }
}
